import type { ProviderVM } from "@shared-kernel/application/ports/provider/provider-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveProviderProfile = createApiThunk<ProviderVM, void>(
  "providers/retrieveProviderProfile",
  async (_: void, { extra: { providerRepository } }) => {
    return providerRepository!.profile();
  },
);
